import StandardSection from 'components/Checkout/Sections/SddSections/StandardSection/StandardSection';
import withStandardSectionProps from 'viewModel/checkout/sections/sddSections/standardSection/withStandardSectionProps';

const StandardSectionWithProps = withStandardSectionProps(StandardSection);

export default StandardSectionWithProps;
